/**
 * Helper condiviso per inviare messaggi con o senza allegati.
 * Sceglie automaticamente l'endpoint corretto:
 *   - files vuoto → JSON (endpoint /messages, invariato)
 *   - files > 0   → multipart (endpoint /messages/with-attachments)
 * Il CSRF header è iniettato automaticamente dall'axios interceptor in lib/api.js.
 */
import { api } from "../../lib/api";

/**
 * @param {string} basePath  es. "/internal/tickets/abc123/messages" (SENZA suffisso with-attachments)
 * @param {{text: string, files?: File[], extra?: object}} opts
 * @returns {Promise<any>} la response.data
 */
export async function postMessageWithOptionalFiles(basePath, { text, files = [], extra = {} }) {
    if (!files || files.length === 0) {
        const body = { text, ...extra };
        const { data } = await api.post(basePath, body);
        return data;
    }
    const form = new FormData();
    form.append("text", text);
    Object.entries(extra).forEach(([k, v]) => {
        if (v !== undefined && v !== null) form.append(k, v);
    });
    for (const f of files) form.append("files", f, f.name);
    // Non impostare Content-Type: axios lo compone con boundary corretto.
    const { data } = await api.post(basePath + "/with-attachments", form, {
        headers: { "Content-Type": "multipart/form-data" },
    });
    return data;
}
